module.exports = __webpack_public_path__ + "static/media/header.c9bd1dd0.jpg";